import React from 'react';
import { compose } from 'recompose';
import Layout from '../utils/layout';
import { graphql } from 'gatsby';
import {
  withAuthorization,
  withEmailVerification,
} from '../utils/Session';
import Campaigns from '../components/scenes/Campaigns/Campaigns';

const condition = authUser => !!authUser;
const CampaignsPage = compose(
  withEmailVerification,
  withAuthorization(condition),
)(Campaigns);

export default () => {
  return (
    <Layout>
      <CampaignsPage />
    </Layout>
  );
};

export const query = graphql`
  query CampaignsSeo {
    site {
      siteMetadata {
        home {
          defaultTitle: title
          titleTemplate
          defaultDescription: description
          siteUrl: url
          defaultImage: image
          twitterUsername
        }
      }
    }
  }
`;
